(function() {
  var SelectBox,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SelectBox = App.loadClass('core::SelectBox');

  exports.WeightSetsTab = (function(superClass) {
    extend(WeightSetsTab, superClass);

    function WeightSetsTab() {
      return WeightSetsTab.__super__.constructor.apply(this, arguments);
    }

    WeightSetsTab.prototype.init = function() {
      var self, sidebar;
      self = this;
      sidebar = $(this.layoutSelector);
      this.subHandlers = {
        'WeightSet': {
          'class': 'portal::handlers/weightings/WeightSetDialog'
        },
        'AddEditWeightSet': {
          'class': 'portal::handlers/weightings/AddEditWeightSetDialog'
        },
        'DeleteWeightSet': {
          'class': 'portal::handlers/weightings/DeleteWeightSetDialog'
        },
        'YieldRanges': {
          'class': 'portal::handlers/weightings/YieldRangesDialog'
        },
        'YieldRangesWithIrr': {
          'class': 'portal::handlers/weightings/YieldRangesWithIrrDialog'
        }
      };
      this.taffyObjects = this.parent.taffyObjects;
      sidebar.find('#sel_ws_pp').on('change', (function(_this) {
        return function() {
          _this.destroyAllSubHandlers();
          return _this.renderWeightSetSelect();
        };
      })(this));
      sidebar.find('#sel_ws_pp').trigger('change');
      sidebar.find('#btn_add_ws').on('click', (function(_this) {
        return function() {
          var handler, pp_id;
          pp_id = sidebar.find('#sel_ws_pp').val();
          handler = _this.createSubHandler('AddEditWeightSet');
          if (handler) {
            handler.loadLayoutPostOptions = {
              pp_id: pp_id
            };
            return handler.init();
          }
        };
      })(this));
      sidebar.find('#weight_set_popover').clickover({
        html: true,
        placement: 'right',
        container: '#bs2-container'
      });
      sidebar.find('#sel_ws').on('change', function() {
        var handler, id, sel_assoc, sel_zones, sz_id;
        id = parseInt($(this).val());
        if (!id) {
          sidebar.find('#toggle_weight_divs').hide();
          self.destroySubHandler('WeightSet', true);
          return;
        }
        sidebar.find('#toggle_weight_divs').show();
        sel_zones = sidebar.find('select[name="sel_zones"]');
        sel_assoc = sidebar.find('select[name="sel_assoc"]');
        self.destroyAllSubHandlers();
        self.renderZoneSelects();
        sz_id = self.taffyObjects.sz({
          weight_sets_id: id
        }).select('id');
        sel_zones.val(sz_id);
        self.moveOptions(sel_zones, sel_assoc);
        handler = self.createSubHandler('WeightSet');
        if (handler) {
          handler.loadLayoutPostOptions = {
            ws_id: id
          };
          return handler.init();
        }
      });
      sidebar.find('#btn_rename_ws').on('click', (function(_this) {
        return function() {
          var handler;
          handler = _this.createSubHandler('AddEditWeightSet');
          if (handler) {
            handler.loadLayoutPostOptions = {
              pp_id: sidebar.find('#sel_ws_pp').val(),
              weight_set_id: sidebar.find('#sel_ws').val()
            };
            return handler.init();
          }
        };
      })(this));
      sidebar.find('#btn_delete_ws').on('click', (function(_this) {
        return function() {
          var handler;
          handler = _this.createSubHandler('DeleteWeightSet');
          if (handler) {
            handler.loadLayoutPostOptions = {
              weight_set_id: sidebar.find('#sel_ws').val()
            };
            return handler.init();
          }
        };
      })(this));
      sidebar.find('#btn_assoc_zones').on('click', (function(_this) {
        return function() {
          return _this.assocZones();
        };
      })(this));
      sidebar.find('#btn_deassoc_zones').on('click', (function(_this) {
        return function() {
          return _this.deassocZones();
        };
      })(this));
      return this.renderWeightSetSelect();
    };

    WeightSetsTab.prototype.renderWeightSetSelect = function(autoselect) {
      var ppID, sidebar, ws;
      if (autoselect == null) {
        autoselect = null;
      }
      sidebar = $(this.layoutSelector);
      ppID = parseInt(sidebar.find('#sel_ws_pp').val());
      ws = this.taffyObjects.ws({
        placement_programs_id: ppID
      }).order('name').select('id', 'name');
      SelectBox.render(ws, sidebar.find('#sel_ws'));
      if (autoselect) {
        return sidebar.find('#sel_ws').val(autoselect).trigger('change');
      } else {
        return sidebar.find('#sel_ws').val('').trigger('change');
      }
    };

    WeightSetsTab.prototype.renderZoneSelects = function() {
      var assigned, ppID, sidebar, unassigned, wsID;
      sidebar = $(this.layoutSelector);
      ppID = parseInt(sidebar.find('#sel_ws_pp').val());
      unassigned = this.taffyObjects.sz({
        placement_programs_id: ppID,
        weight_sets_id: null
      }).order('name').select('id', 'name');
      SelectBox.render(unassigned, sidebar.find('select[name="sel_zones"]'), []);
      wsID = parseInt(sidebar.find('#sel_ws').val());
      assigned = this.taffyObjects.sz({
        weight_sets_id: wsID
      }).order('name').select('id', 'name');
      return SelectBox.render(assigned, sidebar.find('select[name="sel_assoc"]'), []);
    };

    WeightSetsTab.prototype.assocZones = function(doSave) {
      if (doSave == null) {
        doSave = true;
      }
      return this._doAssoc(false, doSave);
    };

    WeightSetsTab.prototype.deassocZones = function(doSave) {
      if (doSave == null) {
        doSave = true;
      }
      return this._doAssoc(true, doSave);
    };

    WeightSetsTab.prototype._doAssoc = function(deassoc, doSave) {
      var fromSel, i, len, retVal, sidebar, toSel, wsID, zone, zones;
      sidebar = $(this.layoutSelector);
      if (deassoc) {
        fromSel = sidebar.find('select[name="sel_assoc"]');
        toSel = sidebar.find('select[name="sel_zones"]');
        wsID = null;
      } else {
        fromSel = sidebar.find('select[name="sel_zones"]');
        toSel = sidebar.find('select[name="sel_assoc"]');
        wsID = parseInt(sidebar.find('#sel_ws').val());
      }
      zones = fromSel.val();
      if (zones == null) {
        return false;
      }
      for (i = 0, len = zones.length; i < len; i++) {
        zone = zones[i];
        this.taffyObjects.sz({
          id: parseInt(zone)
        }).update({
          weight_sets_id: wsID
        });
      }
      retVal = this.moveOptions(fromSel, toSel);
      if (doSave) {
        this._saveSalesZones();
      }
      return retVal;
    };

    WeightSetsTab.prototype.moveOptions = function(from, to) {
      var i, len, sel, val, vals;
      if (!(from instanceof jQuery)) {
        from = $(from);
      }
      if (!(to instanceof jQuery)) {
        to = $(to);
      }
      vals = from.val();
      if (!vals) {
        return false;
      }
      for (i = 0, len = vals.length; i < len; i++) {
        val = vals[i];
        sel = 'option[value="' + val + '"]';
        from.find(sel).appendTo(to);
        from.find(sel).remove();
      }
      to.find('option').sort(this._selectSort).appendTo(to);
      to.val('');
      return true;
    };

    WeightSetsTab.prototype._saveSalesZones = function() {
      var zones, zones_data;
      zones = this.taffyObjects.sz().get();
      zones_data = zones.map(function(zone) {
        var data, ref;
        return data = {
          id: zone.id,
          ws_id: (ref = zone.weight_sets_id) != null ? ref : null
        };
      });
      return $.post('backend/portal/weightings/save-sales-zones', {
        zones: zones_data
      }, function(response) {
        return void 0;
      });
    };

    WeightSetsTab.prototype._selectSort = function(a, b) {
      return strnatcasecmp(a.text, b.text);
    };

    WeightSetsTab.prototype.destroy = function() {
      return WeightSetsTab.__super__.destroy.call(this, false);
    };

    return WeightSetsTab;

  })(Handler);

}).call(this);
